var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-layer__root"},[_c('div',{staticClass:"d-flex justify-center align-center",staticStyle:{"width":"100%","height":"100%"}},[_c('h1',{staticClass:"ml4",staticStyle:{"width":"100%"}})])])
}]

export { render, staticRenderFns }